<app-layout-row>
    <app-layout-column [width]="12">
        <h4>Context Property Filters</h4>
    </app-layout-column>
</app-layout-row>

<ng-container ngModelGroup="filterss">
    @for (filter of filters(); track filter.Id; let i = $index) {
    <fieldset [ngModelGroup]="$safeNavigationMigration(filter.Id?.toString())" #form="ngModelGroup">
        <app-layout-row>
            <app-layout-column [width]="12">
                <app-context-property-filter 
                    [filter]="filter"
                    [readonly]="readonly()"
                    (filterChange)="updateFilter(i, $event)"
                    (onDeleteFilter)="deleteFilter(i)">
                </app-context-property-filter>
                <hr>
            </app-layout-column>
        </app-layout-row>
    </fieldset>
    } @empty {
        <app-layout-row>
            <app-layout-column [width]="12">
                <p>No context property filters have been added yet.</p>
            </app-layout-column>
        </app-layout-row>
    }
</ng-container>

<app-layout-row>
    <app-layout-column [width]="12">
        @if (readonly() === false) {
            <app-link iconClass="dx-icon-add" (onClick)="addFilter()">Add context property filter</app-link>
        }
    </app-layout-column>
</app-layout-row>